import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useRouter } from 'next/router';

export const useSupportConciergeEnabled = (): boolean => {
  const router = useRouter();
  const growthBookEnabled = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.SUPPORT_CONCIERGE,
  );

  return (
    router.isReady &&
    (router.query.allowConcierge === 'true' || growthBookEnabled)
  );
};

/** Banner and login reminder for unread support messages. */
export const useSupportConciergeAlertsEnabled = (): boolean =>
  useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.SUPPORT_CONCIERGE_ALERTS);
